import mixpanel from "mixpanel-browser";

mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN!, {
  api_transport: "sendBeacon",
  persistence: "localStorage",
  // debug: true,
});

type ModuleEvents = {
  transactions: ["capture", "refund", "void", "export"];
};

type AnalyticsModuleEvents = {
  [k in keyof ModuleEvents]:
    | `${k}_${ModuleEvents[k][number]}`
    | `${k}_${ModuleEvents[k][number]}_cancel`
    | `${k}_${ModuleEvents[k][number]}_confirm`
    | `${k}_${ModuleEvents[k][number]}_success`
    | `${k}_${ModuleEvents[k][number]}_error`;
}[keyof ModuleEvents];

type Event = AnalyticsModuleEvents | "page_view";

class AnalyticsManager {
  track(eventName: Event, properties?: Record<string, unknown>) {
    mixpanel.track(eventName, properties);
  }

  reset() {
    mixpanel.reset();
  }
}

export const analytics = new AnalyticsManager();
